import React, { createContext, useReducer, useEffect, useState } from "react";
import axios from "axios";

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
    const [productsData, setProductsData] = useState(null);
    const AllProducts = async () => {
        try {
            const res = await axios.get('https://roughradio.demo-customproject.com/backend/api/shop/get_products');
            setProductsData(res.data.data)
        } catch (err) {
            console.log('product listing err', err)
        }
    };

    useEffect(() => {
        AllProducts();
    }, []);

    return (
        <ProductContext.Provider value={{ productsData }}>
            {children}
        </ProductContext.Provider>
    );
};
